var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomV2TrainingV2(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17.4997H3.33333C2.87333 17.4997 2.5 17.1263 2.5 16.6663V11.6663C2.5 11.2063 2.87333 10.833 3.33333 10.833H5C5.46 10.833 5.83333 11.2063 5.83333 11.6663V16.6663C5.83333 17.1263 5.46 17.4997 5 17.4997Z",
    stroke: "#7A7670",
    style: (_ref2 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.833 14.1669H12.7772C13.138 14.1669 13.4888 14.0502 13.7772 13.8336L15.7905 12.3236C16.293 11.9469 16.9963 11.9969 17.4405 12.4411V12.4411C17.9338 12.9344 17.9338 13.7336 17.4405 14.2261L15.713 15.9536C15.248 16.4186 14.6547 16.7361 14.0097 16.8652L11.568 17.3536C11.0838 17.4502 10.5847 17.4386 10.1055 17.3186L7.89717 16.7669C7.63301 16.7002 7.36217 16.6669 7.08967 16.6669H5.83301",
    stroke: "#7A7670",
    style: (_ref3 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.833 14.1663H12.0705C12.768 14.1663 13.333 13.6013 13.333 12.9038V12.6513C13.333 12.0722 12.9388 11.5672 12.3772 11.4272L10.4672 10.9497C10.1563 10.8722 9.83801 10.833 9.51801 10.833V10.833C8.74551 10.833 7.98967 11.0613 7.34717 11.4905L5.83301 12.4997",
    stroke: "#7A7670",
    style: (_ref4 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.741 2.93488C16.9626 3.11238 17.626 4.30655 17.4801 5.30821C17.1851 7.34071 13.541 8.50988 13.4793 8.50155C13.4176 8.49238 10.2576 6.33405 10.5526 4.30238C10.6985 3.30071 11.6735 2.34488 12.8951 2.52238C13.5935 2.62405 14.0051 3.01738 14.2276 3.34655C14.536 3.09321 15.0426 2.83321 15.741 2.93488V2.93488Z",
    stroke: "#7A7670",
    style: (_ref5 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomV2TrainingV2);
export default __webpack_public_path__ + "static/media/customV2TrainingV2.d73eb3418974717bd0fb02b84d06e16a.svg";
export { ForwardRef as ReactComponent };